import { LRUCache } from '@pacote/lru-cache';
export function memoize(cacheKeyFn, fn, options = {}) {
    const cache = options.capacity
        ? new LRUCache(options.capacity)
        : new Map();
    const memoizedFn = (...args) => {
        const key = cacheKeyFn(...args);
        if (!cache.has(key)) {
            cache.set(key, fn(...args));
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return cache.get(key);
    };
    return Object.assign(memoizedFn, {
        clear: () => {
            return cache.clear();
        },
    });
}
//# sourceMappingURL=index.js.map